import React from 'react';

import './historic_feed.scss';


function TableItem({ className, header, content }) {
  if (!header || !content) throw new SyntaxError('missing one or more required args: header, content');

  if (className?.includes('openTime') || className?.includes('closeTime')) {
    content = content.toString();
    content = (<React.Fragment>
      <span className='AllExceptLeastSignificantSecond'>{content.slice(0, -4)}</span>
      {content.slice(-4, -3)}
      <span className='Milliseconds'>{content.slice(-3,)}</span>
    </React.Fragment>);
  }

  return (<div className={'Item' + (className ? ` ${className}` : ' ')}>
    <div className='Content'>
      {content}
    </div>
    <div className='Header'>
      {header}
    </div>
  </div>);
}

export default TableItem;